import {
  ALL_RULES_LIST_SET,
  RULES_LIST_SET,
  RULES_LIST_REQ,
  RULES_LIST_SUCCESS,
  RULES_LIST_ERROR,
  RULES_LIST_RESET_STATUS,
  PRVILEGED_RULES_LIST_SET,
  MASTER_RULESET_UPLOAD,
  MASTER_RULESET_UPLOAD_SUCCESS,
  MASTER_RULESET_UPLOAD_ERROR,
  OVERRIDE_RULESET_UPLOAD,
  OVERRIDE_RULESET_UPLOAD_SUCCESS,
  OVERRIDE_RULESET_UPLOAD_ERROR,
  RULES_REVISIONS_LIST_REQ,
  RULES_REVISIONS_LIST_SUCCESS,
  RULES_REVISIONS_LIST_ERROR,
  ALLOW_RULES_OVERRIDE,
  RULES_WHITELIST_REQ,
  RULES_WHITELIST_SET,
  RULES_WHITELIST_REQ_SUCCESS,
  RULES_WHITELIST_REQ_ERROR,
  RULES_WHITELIST_CREATE_REQ,
  RULES_WHITELIST_DELETE_REQ
} from './rules.type'

import { getParsedJSON } from '@/utilities/json.helper'
import ApiRest from '@/api/api-rest'
import { rulesListMetaInfo } from '@/column-header/rules/ruleslist-meta'
import { whitelistMetaInfo } from '@/column-header/allowlist/whitelist-meta'
import { IP_ADDRESS_WHITELIST_FIELD_TYPE } from '@/constants/rules.constants'
import IQCollection from '@/resources/collections/IQCollection'
import Rule from '@/resources/models/Rule'
import IPAddressRuleWhitelist from '@/resources/models/allowlist/IPAddressRuleWhitelist'
import ProcessRuleWhitelist from '@/resources/models/allowlist/ProcessRuleWhitelist'
import { OrderByEnum } from '@/constants/orderby.constants'

const state = {
  allRulesList: {},
  rulesListReqStatus: '',
  rulesList: {},
  privilegedRulesList: {},
  uploadMasterRulesetReqStatus: '',
  uploadOverridesReqStatus: '',
  rulesRevisionsListReqStatus: '',
  rulesRevisionsList: [],
  allowRulesOverride: false,
  rulesWhitelistReqStatus: '',
  rulesWhitelist: {},
  remoteHostWhitelistExist: false
}

const getters = {
  allRulesList: state => state.allRulesList,
  rulesListReqStatus: state => state.rulesListReqStatus,
  rulesList: state => state.rulesList,
  privilegedRulesList: state => state.privilegedRulesList,
  uploadMasterRulesetReqStatus: state => state.uploadMasterRulesetReqStatus,
  uploadOverridesReqStatus: state => state.uploadOverridesReqStatus,
  rulesRevisionsListReqStatus: state => state.rulesRevisionsListReqStatus,
  rulesRevisionsList: state => state.rulesRevisionsList,
  allowRulesOverride: state => state.allowRulesOverride,
  rulesWhitelistReqStatus: state => state.rulesWhitelistReqStatus,
  rulesWhitelist: state => state.rulesWhitelist,
  remoteHostWhitelistExist: state => state.remoteHostWhitelistExist
}

// Best Practice - updates state
const mutations = {
  [ALL_RULES_LIST_SET]: (state, data) => {
    state.allRulesList = data
  },
  [RULES_LIST_SET]: (state, data) => {
    state.rulesList = data
  },
  [PRVILEGED_RULES_LIST_SET]: (state, data) => {
    state.privilegedRulesList = data
  },
  [RULES_LIST_REQ]: state => {
    state.rulesListReqStatus = 'loading'
  },
  [RULES_LIST_SUCCESS]: (state, data) => {
    state.rulesListReqStatus = 'saved'
  },
  [RULES_LIST_ERROR]: (state, errMsg) => {
    state.rulesListReqStatus = 'error'
  },
  [RULES_LIST_RESET_STATUS]: state => {
    state.rulesListReqStatus = ''
  },
  [MASTER_RULESET_UPLOAD]: state => {
    state.uploadMasterRulesetReqStatus = ''
  },
  [MASTER_RULESET_UPLOAD_SUCCESS]: (state, data) => {
    state.uploadMasterRulesetReqStatus = 'saved'
  },
  [MASTER_RULESET_UPLOAD_ERROR]: (state, data) => {
    state.uploadMasterRulesetReqStatus = 'error'
  },
  [OVERRIDE_RULESET_UPLOAD]: state => {
    state.uploadOverridesReqStatus = ''
  },
  [OVERRIDE_RULESET_UPLOAD_SUCCESS]: (state, data) => {
    state.uploadOverridesReqStatus = 'saved'
  },
  [OVERRIDE_RULESET_UPLOAD_ERROR]: (state, data) => {
    state.uploadOverridesReqStatus = 'error'
  },
  [RULES_REVISIONS_LIST_REQ]: state => {
    state.rulesRevisionsListReqStatus = ''
  },
  [RULES_REVISIONS_LIST_SUCCESS]: (state, data) => {
    state.rulesRevisionsListReqStatus = 'saved'
    state.rulesRevisionsList = data
  },
  [RULES_REVISIONS_LIST_ERROR]: state => {
    state.rulesRevisionsListReqStatus = 'error'
  },
  [ALLOW_RULES_OVERRIDE]: (state, allowOverrides) => {
    state.allowRulesOverride = allowOverrides
  },
  [RULES_WHITELIST_REQ]: state => {
    state.rulesWhitelistReqStatus = 'loading'
  },
  [RULES_WHITELIST_SET]: (state, data) => {
    state.rulesWhitelist = data
    state.remoteHostWhitelistExist = false
    if (_.some(data.models, ['field', 'remoteHost'])) {
      state.remoteHostWhitelistExist = true
    }
  },
  [RULES_WHITELIST_REQ_SUCCESS]: (state, data) => {
    state.rulesWhitelistReqStatus = 'saved'
  },
  [RULES_WHITELIST_REQ_ERROR]: state => {
    state.rulesWhitelistReqStatus = 'error'
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [RULES_LIST_REQ] (context) {
    return new Promise((resolve, reject) => {
      context.commit(RULES_LIST_REQ)
      ApiRest()
        .get('/ruleslist')
        // .get('static/json/ruleslist.json')
        .then(({ data }) => {
          let tactics = context.rootState.mitreAttack.mitreTacticList
          let techniques = context.rootState.mitreAttack.mitreTechniqueList
          if (data) {
            context.commit(ALLOW_RULES_OVERRIDE, data.allowOverrides)
            if (data['rules']) {
              data = data['rules']
            }
            data = data.map(rule => {
              let iqRule = new Rule('id', getParsedJSON(rule))
              let mitreTactic = _.find(tactics, tactic => {
                let matchTacticRef = _.find(tactic.external_references, {
                  external_id: iqRule.tactic
                })
                if (matchTacticRef) {
                  iqRule.setExternalTacticUrl(matchTacticRef.url)
                  return true
                }
                return false
              })
              iqRule.setTactic(mitreTactic)
              let mitreTechnique = _.find(techniques, technique => {
                let matchTechniqueRef = _.find(technique.external_references, {
                  external_id: iqRule.technique
                })
                if (matchTechniqueRef) {
                  iqRule.setExternalTechniqueUrl(matchTechniqueRef.url)
                  return true
                }
                return false
              })
              iqRule.setTechnique(mitreTechnique)
              return iqRule
            })
          }

          // keep a list of all ruleset
          context.commit(ALL_RULES_LIST_SET, data)

          // skip deprecated rules
          let rules = new IQCollection(
            _.filter(data, rule => {
              return (
                rule.score !== 'ZERO' && (_.isUndefined(rule.deprecated) || rule.deprecated === false) && rule.tactic
              )
            }),
            { attributes: rulesListMetaInfo.meta.columns },
            { defaultSort: 'id', sortOrder: OrderByEnum.ASC }
          )

          let privilegeRules = new IQCollection(
            _.filter(data, rule => {
              return (
                rule.score === 'ZERO' && (_.isUndefined(rule.deprecated) || rule.deprecated === false) && rule.tactic
              )
            }),
            { attributes: rulesListMetaInfo.meta.columns },
            { defaultSort: 'id', sortOrder: OrderByEnum.ASC }
          )

          context.commit(RULES_LIST_SET, rules)
          context.commit(PRVILEGED_RULES_LIST_SET, privilegeRules)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(RULES_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [RULES_LIST_SUCCESS] (context) {
    context.commit(RULES_LIST_SUCCESS)
  },
  [RULES_LIST_RESET_STATUS] (context) {
    context.commit(RULES_LIST_RESET_STATUS)
  },
  [MASTER_RULESET_UPLOAD] (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(MASTER_RULESET_UPLOAD)
      // let formData = new FormData()
      // formData.set('ruleset', JSON.stringify(payload.ruleset))
      // formData.set('version', payload.version)
      // formData.set('minAgentVersion', payload.minAgentVersion)
      // formData.append('file', payload.rulesetFile)
      ApiRest()
        .post('/rules/master', {
          ruleset: payload.ruleset,
          version: payload.version,
          minAgentVersion: payload.minAgentVersion
        })
        .then(({ data }) => {
          context.commit(MASTER_RULESET_UPLOAD_SUCCESS)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(MASTER_RULESET_UPLOAD_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [OVERRIDE_RULESET_UPLOAD] (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(OVERRIDE_RULESET_UPLOAD)
      let overrides = []
      payload.ruleset.forEach(rule => {
        overrides.push({
          id: rule.id.toString(),
          ruleId: rule.id.toString(),
          enabled: rule.enabled,
          score: rule.score
        })
      })
      ApiRest()
        .post('/rules/customer/overrides', { ruleset: overrides })
        .then(({ data }) => {
          context.commit(OVERRIDE_RULESET_UPLOAD_SUCCESS)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(OVERRIDE_RULESET_UPLOAD_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [RULES_REVISIONS_LIST_REQ] (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(RULES_REVISIONS_LIST_REQ)
      ApiRest()
        .get('/rules/revisions')
        .then(({ data }) => {
          context.commit(RULES_REVISIONS_LIST_SUCCESS, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(RULES_REVISIONS_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [RULES_WHITELIST_REQ] (context) {
    return new Promise((resolve, reject) => {
      context.commit(RULES_WHITELIST_REQ)
      ApiRest()
        .get('/rules/whitelist')
        .then(({ data }) => {
          data = data.map(whitelist => {
            switch (whitelist.field) {
              case IP_ADDRESS_WHITELIST_FIELD_TYPE:
                let ipWl = new IPAddressRuleWhitelist('key', whitelist)
                ipWl.selectNetworkRules(context.rootState.rules.allRulesList)
                return ipWl
              default:
                return new ProcessRuleWhitelist('key', whitelist)
            }
          })
          let whitelist = new IQCollection(
            data,
            { attributes: whitelistMetaInfo.meta.columns },
            { defaultSort: 'key', sortOrder: OrderByEnum.ASC }
          )
          context.commit(RULES_WHITELIST_SET, whitelist)
          resolve(whitelist)
        })
        .catch(errMsg => {
          context.commit(RULES_WHITELIST_REQ_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [RULES_WHITELIST_REQ_SUCCESS] (context) {
    context.commit(RULES_WHITELIST_REQ_SUCCESS)
  },
  [RULES_WHITELIST_CREATE_REQ] (context, newWhitelists) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('/rules/whitelist', { whitelists: newWhitelists })
        .then(({ data }) => {
          resolve({})
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [RULES_WHITELIST_DELETE_REQ] (context, whitelist) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .delete(`/rules/whitelist/${whitelist.key}`)
        .then(({ data }) => {
          resolve({})
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/rules/rules.module.js